var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-swipe',{attrs:{"autoplay":3000}},_vm._l((_vm.banners),function(item,index){return _c('van-swipe-item',{key:item.href + index},[_c('van-image',{attrs:{"src":item.icon,"fit":"fill"},on:{"click":function($event){return _vm.onClicked(item.href)}}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }